/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.4-12-g918a4012-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ParameterValues interface.
 */
export function instanceOfParameterValues(value) {
    if (!('allowOwnCredentialManagement' in value) || value['allowOwnCredentialManagement'] === undefined)
        return false;
    if (!('sshClientAuthPublickey' in value) || value['sshClientAuthPublickey'] === undefined)
        return false;
    if (!('sshClientAuthPassword' in value) || value['sshClientAuthPassword'] === undefined)
        return false;
    if (!('sshClientAuthKeyboardInteractive' in value) || value['sshClientAuthKeyboardInteractive'] === undefined)
        return false;
    if (!('minimizePasswordLogin' in value) || value['minimizePasswordLogin'] === undefined)
        return false;
    return true;
}
export function ParameterValuesFromJSON(json) {
    return ParameterValuesFromJSONTyped(json, false);
}
export function ParameterValuesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'allowOwnCredentialManagement': json['allow_own_credential_management'],
        'rateLimitBytesPerSecond': json['rate_limit_bytes_per_second'] == null ? undefined : json['rate_limit_bytes_per_second'],
        'sshClientAuthPublickey': json['ssh_client_auth_publickey'],
        'sshClientAuthPassword': json['ssh_client_auth_password'],
        'sshClientAuthKeyboardInteractive': json['ssh_client_auth_keyboard_interactive'],
        'minimizePasswordLogin': json['minimize_password_login'],
    };
}
export function ParameterValuesToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'allow_own_credential_management': value['allowOwnCredentialManagement'],
        'rate_limit_bytes_per_second': value['rateLimitBytesPerSecond'],
        'ssh_client_auth_publickey': value['sshClientAuthPublickey'],
        'ssh_client_auth_password': value['sshClientAuthPassword'],
        'ssh_client_auth_keyboard_interactive': value['sshClientAuthKeyboardInteractive'],
        'minimize_password_login': value['minimizePasswordLogin'],
    };
}
